export default __webpack_public_path__ + "baa32b9c5e96600ba2abea2847d2aaa1.svg";